module.exports = __webpack_public_path__ + "img/soja.ca9d28a1.svg";